"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _FileUploader = _interopRequireDefault(require("./FileUploader"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "file-uploader": "DefaultTheme__file-uploader___2MsDp",
  "is-disabled": "DefaultTheme__is-disabled___1FF21",
  "filename": "DefaultTheme__filename___3HYkz",
  "empty": "DefaultTheme__empty___3CjFP",
  "has-error": "DefaultTheme__has-error___1_0fY",
  "file-uploader-button": "DefaultTheme__file-uploader-button___1PVKm",
  "spinner": "DefaultTheme__spinner___3E7dC",
  "fileUploader": "DefaultTheme__file-uploader___2MsDp",
  "isDisabled": "DefaultTheme__is-disabled___1FF21",
  "hasError": "DefaultTheme__has-error___1_0fY",
  "fileUploaderButton": "DefaultTheme__file-uploader-button___1PVKm"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "file-uploader": "DarkTheme__file-uploader___2zpX4",
  "file-uploader-text-field": "DarkTheme__file-uploader-text-field___3UT79",
  "is-dirty": "DarkTheme__is-dirty___3BrNe",
  "is-valid": "DarkTheme__is-valid___2Sery",
  "has-error": "DarkTheme__has-error___2F6iS",
  "fileUploader": "DarkTheme__file-uploader___2zpX4",
  "fileUploaderTextField": "DarkTheme__file-uploader-text-field___3UT79",
  "isDirty": "DarkTheme__is-dirty___3BrNe",
  "isValid": "DarkTheme__is-valid___2Sery",
  "hasError": "DarkTheme__has-error___2F6iS"
};
require("./themes/LumeTheme.css");
var LumeTheme = {
  "file-uploader": "LumeTheme__file-uploader___3GUcF",
  "fileUploader": "LumeTheme__file-uploader___3GUcF"
};
require("../Button/themes/DefaultTheme.css");
var ButtonDefaultTheme = {
  "button": "DefaultTheme__button___29mtS",
  "primary": "DefaultTheme__primary___249es",
  "neutral": "DefaultTheme__neutral___3ZBg8",
  "no-fill": "DefaultTheme__no-fill___1Pw4q",
  "secondary": "DefaultTheme__secondary___1JUnQ",
  "tertiary": "DefaultTheme__tertiary___3cLHz",
  "flat": "DefaultTheme__flat___1g85K",
  "danger": "DefaultTheme__danger___hdJjA",
  "inverse": "DefaultTheme__inverse___i4aAH",
  "sm": "DefaultTheme__sm___IcJN8",
  "spinner": "DefaultTheme__spinner___1NECm",
  "md": "DefaultTheme__md___1s5qL",
  "lg": "DefaultTheme__lg___o_Th1",
  "circular": "DefaultTheme__circular___3nFPO",
  "is-loading": "DefaultTheme__is-loading___z_iqy",
  "children": "DefaultTheme__children___WfQFi",
  "noFill": "DefaultTheme__no-fill___1Pw4q",
  "isLoading": "DefaultTheme__is-loading___z_iqy"
};
require("../Button/themes/DarkTheme.css");
var ButtonDarkTheme = {
  "button": "DarkTheme__button___2kIdG",
  "disabled": "DarkTheme__disabled___1M4kT",
  "no-fill": "DarkTheme__no-fill___2QrWc",
  "primary": "DarkTheme__primary___3Uk1Z",
  "secondary": "DarkTheme__secondary___2kdte",
  "tertiary": "DarkTheme__tertiary___2Ictb",
  "flat": "DarkTheme__flat___Z46o6",
  "danger": "DarkTheme__danger___38aEz",
  "noFill": "DarkTheme__no-fill___2QrWc"
};
require("../Button/themes/LumeTheme.css");
var ButtonLumeTheme = {
  "button": "LumeTheme__button___2d3zl"
};
require("../TextField/themes/DefaultTheme.css");
var TextFieldDefaultTheme = {
  "text-field": "DefaultTheme__text-field___fBqG3",
  "is-dirty": "DefaultTheme__is-dirty___12Ha8",
  "has-error": "DefaultTheme__has-error___wbsII",
  "is-password-type": "DefaultTheme__is-password-type___1-Ae3",
  "search": "DefaultTheme__search___Wk7X8",
  "clear": "DefaultTheme__clear___-8sfQ",
  "show-hide-password": "DefaultTheme__show-hide-password___2B8RC",
  "textField": "DefaultTheme__text-field___fBqG3",
  "isDirty": "DefaultTheme__is-dirty___12Ha8",
  "hasError": "DefaultTheme__has-error___wbsII",
  "isPasswordType": "DefaultTheme__is-password-type___1-Ae3",
  "showHidePassword": "DefaultTheme__show-hide-password___2B8RC"
};
require("../TextField/themes/DarkTheme.css");
var TextFieldDarkTheme = {
  "text-field": "DarkTheme__text-field___wMCf_",
  "is-focused": "DarkTheme__is-focused___3BIhD",
  "textField": "DarkTheme__text-field___wMCf_",
  "isFocused": "DarkTheme__is-focused___3BIhD"
};
require("../TextField/themes/LumeTheme.css");
var TextFieldLumeTheme = {
  "text-field": "LumeTheme__text-field___3mZTa",
  "textField": "LumeTheme__text-field___3mZTa"
};
require("../Spinner/themes/DefaultTheme.css");
var SpinnerDefaultTheme = {
  "spin": "DefaultTheme__spin___2BLHD",
  "spinner": "DefaultTheme__spinner___1ZqfV",
  "s": "DefaultTheme__s___1Ezcf",
  "m": "DefaultTheme__m___FFO2l",
  "l": "DefaultTheme__l___3u_d-"
};
require("../Spinner/themes/DarkTheme.css");
var SpinnerDarkTheme = {
  "spinner": "DarkTheme__spinner___3yNHB",
  "s": "DarkTheme__s___1X_Gq",
  "m": "DarkTheme__m___1T7UJ",
  "l": "DarkTheme__l___3zdVO"
};
require("../Spinner/themes/LumeTheme.css");
var SpinnerLumeTheme = {
  "spinner": "LumeTheme__spinner___1zWlc"
};
DefaultTheme.Button = ButtonDefaultTheme;
DarkTheme.Button = ButtonDarkTheme;
LumeTheme.Button = ButtonLumeTheme;
DefaultTheme.TextField = TextFieldDefaultTheme;
DarkTheme.TextField = TextFieldDarkTheme;
LumeTheme.TextField = TextFieldLumeTheme;
DefaultTheme.Spinner = SpinnerDefaultTheme;
DarkTheme.Spinner = SpinnerDarkTheme;
LumeTheme.Spinner = SpinnerLumeTheme;
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme,
  LumeTheme: LumeTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)(_FileUploader["default"].displayName, themes.DefaultTheme)(_FileUploader["default"]);
ThemedComponent.displayName = _FileUploader["default"].displayName;
ThemedComponent.themes = themes;
ThemedComponent.isFormComponent = true;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map